exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Icon-d798e3e5{height:1.06667em;width:1.06667em;display:inline-block;position:relative}.Icon-d798e3e5 svg{left:0;bottom:-0.15em;position:absolute;width:100%;height:100%;fill:currentColor;stroke:currentColor}.Icon-d798e3e5.hasSize-b822077f{height:1em;width:1em;vertical-align:middle}.Icon-d798e3e5.hasSize-b822077f svg{bottom:0}\n", ""]);

// Exports
exports.locals = {
	"Icon": "Icon-d798e3e5",
	"hasSize": "hasSize-b822077f"
};